import React, { FC } from "react";
// libs
import NextImage from "next/image";
// components
import Button from "src/components/ui/button";
import ChooseDate from "src/components/containers/appointment/request/chooseDateTime/chooseDate/ChooseDate";
import ChooseTime from "src/components/containers/appointment/request/chooseDateTime/chooseTime/ChooseTime";
// redux
import { setRequestDate, setRequestTime, setRequestStep } from "src/redux/slices/appointment";
// hooks
import { useAppDispatch } from "src/hooks";
import { useRouter } from "next/router";
// const
import { EVariants } from "src/constants/variants";
// theme
import {
  Wrapper,
  RequestSection,
  DropdownSection,
  ImageWrapper,
  Text,
  Content,
} from "./appointment.styles";
import { amplitudeEvent, formatEventName } from "src/libs/amplitude";
import { LargeTitle } from "src/theme/typography";
import { colors } from "src/theme";

const Appointment: FC = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const onChangeDate = (data: string) => {
    dispatch(setRequestDate({ date: data }));
  };

  const onChangeTime = (data: string) => {
    dispatch(setRequestTime({ time: data }));
  };

  const startRequest = () => {
    amplitudeEvent(formatEventName(router.pathname, "appointment", "start_request"));
    dispatch(setRequestStep({ step: 0 }));
    router.push("/appointment/request");
  };

  return (
    <Wrapper>
      <Content>
        <RequestSection>
          <LargeTitle textColor={colors.white}>Request an appointment</LargeTitle>

          <DropdownSection>
            <ChooseDate onChangeCb={onChangeDate} />
            <Text>in the</Text>
            <ChooseTime onChangeCb={onChangeTime} />
          </DropdownSection>

          <Button variant={EVariants.QUATERNARY} onClick={startRequest}>
            Start request
          </Button>
        </RequestSection>

        <ImageWrapper>
          <NextImage src="/illustrations/Alone Time 1.svg" width={750} height={349} />
        </ImageWrapper>
      </Content>
    </Wrapper>
  );
};

export default Appointment;
